module.exports = __webpack_public_path__ + "img/outubro_rosa.76cbdcfb.svg";